'use strict';

var _regeneratorRuntime = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _asyncToGenerator = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var CID = require('cids');

var multihash = require('multihashes');

var configure = require('../lib/configure');

var multipartRequest = require('../lib/multipart-request');

var toUrlSearchParams = require('../lib/to-url-search-params');

var abortSignal = require('../lib/abort-signal');

var _require = require('native-abort-controller'),
    AbortController = _require.AbortController;

var multicodec = require('multicodec');

var loadFormat = require('../lib/ipld-formats');
/**
 * @typedef {import('../types').HTTPClientExtraOptions} HTTPClientExtraOptions
 * @typedef {import('ipfs-core-types/src/dag').API<HTTPClientExtraOptions>} DAGAPI
 */


module.exports = configure(function (api, opts) {
  var load = loadFormat(opts.ipld);
  /**
   * @type {DAGAPI["put"]}
   */

  var put = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dagNode) {
      var options,
          encodingOptions,
          cid,
          settings,
          format,
          serialized,
          controller,
          signal,
          res,
          data,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

              if (!(options.cid && (options.format || options.hashAlg))) {
                _context.next = 5;
                break;
              }

              throw new Error('Failed to put DAG node. Provide either `cid` OR `format` and `hashAlg` options');

            case 5:
              if (!(options.format && !options.hashAlg || !options.format && options.hashAlg)) {
                _context.next = 7;
                break;
              }

              throw new Error('Failed to put DAG node. Provide `format` AND `hashAlg` options');

            case 7:
              if (options.cid) {
                cid = new CID(options.cid);
                encodingOptions = _objectSpread(_objectSpread({}, options), {}, {
                  format: multicodec.getName(cid.code),
                  hashAlg: multihash.decode(cid.multihash).name
                });
                delete options.cid;
              } else {
                encodingOptions = options;
              }

              settings = _objectSpread({
                format: 'dag-cbor',
                hashAlg: 'sha2-256',
                inputEnc: 'raw'
              }, encodingOptions); // @ts-ignore settings.format might be an invalid CodecName

              _context.next = 11;
              return load(settings.format);

            case 11:
              format = _context.sent;
              serialized = format.util.serialize(dagNode); // allow aborting requests on body errors

              controller = new AbortController();
              signal = abortSignal(controller.signal, settings.signal); // @ts-ignore https://github.com/ipfs/js-ipfs-utils/issues/90

              _context.t0 = api;
              _context.t1 = _objectSpread;
              _context.t2 = {
                timeout: settings.timeout,
                signal: signal,
                searchParams: toUrlSearchParams(settings)
              };
              _context.next = 20;
              return multipartRequest(serialized, controller, settings.headers);

            case 20:
              _context.t3 = _context.sent;
              _context.t4 = (0, _context.t1)(_context.t2, _context.t3);
              _context.next = 24;
              return _context.t0.post.call(_context.t0, 'dag/put', _context.t4);

            case 24:
              res = _context.sent;
              _context.next = 27;
              return res.json();

            case 27:
              data = _context.sent;
              return _context.abrupt("return", new CID(data.Cid['/']));

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function put(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return put;
});